// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_p5-0";
export var discountCodeInput = "_p5-1";